import { useEffect } from 'react'
import type { CenterCanvasConfig } from '../types/center-canvas-config'

/** Reports the zoom level actually on screen: the fitted scale in fit mode, else `zoom`. */
export function useEffectiveZoomLevel({
  zoom,
  scale,
  onEffectiveZoomLevelChange,
}: {
  zoom: number
  scale: number
  onEffectiveZoomLevelChange: CenterCanvasConfig['onEffectiveZoomLevelChange']
}) {
  useEffect(() => {
    const level = zoom === 0 ? scale : zoom

    onEffectiveZoomLevelChange?.(+level.toFixed(3))
  }, [zoom, scale, onEffectiveZoomLevelChange])
}
